module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDM4IDIiPgoJPGRlZnM+CgkJPHN0eWxlPgoJCQkuY2xzLTF7ZmlsbDojNDM0MzQ1O30KCQk8L3N0eWxlPgoJPC9kZWZzPgoJPGcgaWQ9IkxheWVyXzIiIGRhdGEtbmFtZT0iTGF5ZXIgMiI+CgkJPGcgaWQ9IkxheWVyXzEtMiIgZGF0YS1uYW1lPSJMYXllciAxIj4KCQkJPHBvbHlnb24gY2xhc3M9ImNscy0xIiBwb2ludHM9IjAgMSAxMjkuNzUgMC41MSAyNTkuNSAwLjIzIDUxOSAwIDc3OC41IDAuMjMgOTA4LjI1IDAuNTEgMTAzOCAxIDkwOC4yNSAxLjQ5IDc3OC41IDEuNzcgNTE5IDIgMjU5LjUgMS43NiAxMjkuNzUgMS40OSAwIDEiIC8+CgkJPC9nPgoJPC9nPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-img/svg-img/vertical-line.svg
// module id = 551
// module chunks = 173